import { EPHONE_PREFIXES } from '@/domains/partners/multisport/enums/PhonePrefix'

export const PHONE_PREFIXES = [
  {
    text: 'form.phonePrefix.poland',
    value: EPHONE_PREFIXES.POLAND,
  },
  {
    text: 'form.phonePrefix.turkey',
    value: EPHONE_PREFIXES.TURKEY,
  },
  {
    text: 'form.phonePrefix.bulgaria',
    value: EPHONE_PREFIXES.BULGARIA,
  },
  {
    text: 'form.phonePrefix.croatia',
    value: EPHONE_PREFIXES.CROATIA,
  },
  {
    text: 'form.phonePrefix.czechRepublic',
    value: EPHONE_PREFIXES.CZECH_REPUBLIC,
  },
  {
    text: 'form.phonePrefix.slovakia',
    value: EPHONE_PREFIXES.SLOVAKIA,
  },
]
